import { render, staticRenderFns } from "./MhlvSelection.vue?vue&type=template&id=71e77665"
import script from "./MhlvSelection.vue?vue&type=script&lang=js"
export * from "./MhlvSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports